export default __webpack_public_path__ + "static/vertical-4fa5cbff5f9dfb50ce94e1bcb0efb4b7.png";